import React, { useEffect, useState } from 'react';
import HeaderDemand from '../../components/atoms/headerDemand';
import { useMainContext } from "../../contexts/MainContext";
import Dropdown from "../../components/atoms/Dropdown";
import { RestActions } from "../../actions";
import './styles.css';

const Profile = ({ preloadReady }) => {
  const rest = new RestActions();

  const [dataprofile, setDataprofile] = useState({ email: '', userName: '' });
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [profileOptions, setProfileOptions] = useState([]);

  let mainContext = useMainContext();


  useEffect(() => {
    if (preloadReady) {
      setDataprofile({ email: mainContext.session.email || mainContext.session.username || mainContext.session.fullNameUser, userName: mainContext.session.fullNameUser });
      findProfile();
    }
  }, [preloadReady, mainContext.session]);

  useEffect(() => {
    if (profileOptions.length > 0 && mainContext.session.profileID) {
      let defaultProfile = profileOptions.find(profile => profile.id === mainContext.session.profileID);
      setSelectedProfile(defaultProfile);
    }
  }, [profileOptions, dataprofile]);

  const findProfile = async () => {
    mainContext.setIsLoading(true);
    try {
      let response = await rest.get("getAllTypesProfile");
      setProfileOptions(response);
      // setDataTable(response);
      mainContext.setIsLoading(false);
    }
    catch (error) {/*TODO SOMETHING*/ }
  }

  const onProfileChange = async (e) => {
    setSelectedProfile(e.value);
  }


  const saveProfile = async () => {
    if (selectedProfile) {
      mainContext.setIsLoading(true);
      try {
        let params = {
          userID: mainContext.session.userID,
          profileTypeID: selectedProfile.id,
          userModifies: mainContext.session.userID
        };
        let response = await rest.postNew("updateProfileDataUser", params);
        if (response.type_profile_id) {
          //Update session profileID
          let newSession = { ...mainContext.session };
          newSession.profileID = selectedProfile.type_profile_id;
          mainContext.setSession(newSession);
          alert("Perfil guardado correctamente.");
        }
        mainContext.setIsLoading(false);
      }
      catch (error) {/*TODO SOMETHING*/ }
    } else {
      alert("Seleccione un perfil antes de guardar.");
    }
  }

  return (
    (preloadReady) &&
    <section className="">
      <HeaderDemand />
      <section className='container'>
        <h2 style={{ marginTop: "2em", fontSize: "3em" }}>Perfil</h2>


        <div className="row px-md-5 mb-5 tableGeneralData">
          <div className="col col-12">
            <div className="custom-card">
              <div className="custom-card-header p-3">
                <h4>DATOS GENERALES</h4>
              </div>
              <div className="custom-card-body px-3 contentDataProfile">

                <div className='circleNameProfile'>
                  {dataprofile.userName ? (dataprofile.userName.split(' ')[0].charAt(0) + (dataprofile.userName.split(' ')[1] ? dataprofile.userName.split(' ')[1].charAt(0) : '')) : ''}
                </div>

                <div className='allDataProfile'>

                  <div className='dataProfileItem'>
                    <span className='dataProfileLabel'>Usuario:</span>
                    <span className='dataProfileValue'>{dataprofile.userName}</span>
                  </div>

                  <div className='dataProfileItem'>
                    <span className='dataProfileLabel'>E-Mail:</span>
                    <span className='dataProfileValue'>{dataprofile.email}</span>
                  </div>

                  <div className='dataProfileItem'>
                    <span className='dataProfileLabel'>Servicio 4S predeterminado:</span>
                    <span className='dataProfileValue' style={{ width: '9em' }}>
                      <Dropdown value={selectedProfile} options={profileOptions} onChange={onProfileChange} optionLabel="name" optionValue="id" />
                    </span>
                    <button className='btn btn-primary btn-sm ml-3' style={{ width: '8em' }} onClick={() => saveProfile()}>Guardar</button>
                  </div>

                </div>


              </div>
            </div>
          </div>
        </div>

      </section>
    </section>
  )
}
export default Profile;